/**
 * Test for touch device.
 */

define('libs/utilities.istouch',[],function() {

    'use strict';

    return function() {
        return !!('ontouchstart' in window || navigator.msMaxTouchPoints);
    };

});

